// Native disclosures keep footer navigation usable with keyboard and without JS.
class RfFooterNav extends HTMLElement {
  connectedCallback() {
    this.media = window.matchMedia('(max-width: 749px)');
    this.sync = () => this.querySelectorAll('details').forEach(detail => {
      detail.open = !this.media.matches;
      const summary = detail.querySelector('summary');
      summary.tabIndex = this.media.matches ? 0 : -1;
      if (this.media.matches) summary.removeAttribute('aria-disabled');
      else summary.setAttribute('aria-disabled', 'true');
    });
    this.keepDesktopOpen = event => {
      if (!this.media.matches && event.target.closest('summary')) event.preventDefault();
    };
    this.addEventListener('click', this.keepDesktopOpen);
    this.media.addEventListener('change', this.sync);
    this.sync();
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.keepDesktopOpen);
    this.media.removeEventListener('change', this.sync);
  }
}
if (!customElements.get('rf-footer-nav')) customElements.define('rf-footer-nav', RfFooterNav);
